import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavItem } from '../../interfaces/userContext';
import NavGroupChildren from './NavGroupChildren';
import './style.css';
import NavListItem from './NavListItem';

export interface NavGroup {
    parent: NavItem;
    children: NavItem[];
}

export interface NavGroupItemProps {
    group: NavGroup;
    collapsed: boolean;
    expanded: boolean;
    onToggle: (order: string) => void;
    open: boolean
}

const NavGroupItem: React.FC<NavGroupItemProps> = ({
    group,
    collapsed,
    expanded,
    onToggle,
    open
}) => {
    const { parent, children } = group;
    const navigate = useNavigate();

    const handleParentClick = () => {
        if (children.length > 0) {
            onToggle(parent.order);
        } else {
            navigate(`vision/${parent.path}`);
        }
    };

    return (
        <>
            <NavListItem
                onClick={handleParentClick}
                className="nav-group-item"
                iconName={parent.icon}
                label={parent.name}
                expanded={expanded}
                collapsed={collapsed}
                hasChildren={children.length > 0}
                onToggle={onToggle as any}
                parent={parent}
                open={open}
                activePath={parent.path}
            />
            {!collapsed && children.length > 0 && (
                <NavGroupChildren
                    childrenItems={children}
                    expanded={expanded}
                    open={open}
                />
            )}
        </>
    );
};

export default NavGroupItem;